import { ReduxState } from '../../../types'

export const selectCblConfig = (state: ReduxState) => state.app
export const selectAppReady = (state: ReduxState) => state.app.appReady
export const selectIsDevelopment = (state: ReduxState) => state.app.isDevelopment
export const selectIsLocalhost = (state: ReduxState) => state.app.isLocalhost
export const selectFlowId = (state: ReduxState) => state.app.flowId

export const isSessionExpired = (state: ReduxState) => state.app.sessionExpired

// feature flags
export const selectFFlagOnline = (state: ReduxState) => state.app.featureFlags?.ONLINE
